import { AvatarSelect } from "./avatar-select/AvatarSelect";
import { LanguageSelect } from "./LanguageSelect";
import { VideoQualitySelect } from "./VideoQualitySelect";
import { VoiceSpeedSlider } from "./VoiceSpeedSlider";
import { VoiceEmotionSelect } from "./VoiceEmotionSelect";

export function HeygenAvatarSettings() {
  return (
    <div className="space-y-4">
      <AvatarSelect />
      <LanguageSelect />
      <VideoQualitySelect />
      <VoiceSpeedSlider />
      <VoiceEmotionSelect />
    </div>
  );
}
